module.exports = __webpack_public_path__ + "img/login.b9568fe8.png";